<template>
  <div class="content-container">
    <div v-loading="loading" class="grid-scroll">
      <GridVx
        ref="agGrid"
        :columns="columns"
        :auto-size-cell="true"
        :auto-select-first-row="false"
        dom-layout="scroll"
        :rows="rows"
        class="agGrid"
        @rowClicked="rowSelected = true"
      />
    </div>
    <div class="button-containers mb-0">
      <button
        :disabled="!rowSelected"
        class="btn primary small outline"
        @click="deleteRow"
      >
        {{ $t('button.delete') }}
      </button>
      <button
        :disabled="!rowSelected"
        class="btn primary small outline"
        @click="editRow"
      >
        {{ $t('button.modify') }}
      </button>
      <button class="btn primary small" @click="dialogFormVisible = true">
        {{ $t('button.add') }}
      </button>
    </div>
    <!--  -->
    <el-dialog
      :title="
        isEdit
          ? $t('dialog.titleTypeOfWorkEdit')
          : $t('dialog.titleTypeOfWorkAdd')
      "
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <validation-observer ref="formValidator">
        <div class="das-form-container">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <validation-provider rules="required|max:20" name="Mã">
                  <div class="das-form-input">
                    <div class="label required">{{ $t('dialog.code') }}</div>
                    <div class="child-w-80">
                      <input
                        v-model="item.code"
                        type="text"
                        :readonly="isEdit"
                      />
                    </div>
                  </div>
                </validation-provider>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <validation-provider rules="required|max: 100" name="Mô tả">
                  <div class="das-form-input">
                    <div class="label required">{{ $t('dialog.desc') }}</div>
                    <div class="child-w-80">
                      <textarea v-model="item.desc" rows="4" />
                    </div>
                  </div>
                </validation-provider>
              </div>
            </div>
          </div>
        </div>
      </validation-observer>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="dialogFormVisible = false"
          >
            {{ $t('button.cancel') }}
          </button>
          <button v-if="isEdit" class="btn primary small" @click="updateRow">
            {{ $t('button.update') }}
          </button>
          <button v-else class="btn primary small" @click="addRow">
            {{ $t('button.create') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// eslint-disable-next-line
import { getCode, addCode, updateCode, deleteCode } from '@/api/common/code'
export default {
  components: {},
  data() {
    return {
      rowSelected: false,
      loading: false,
      isEdit: false,
      dialogFormVisible: false,
      item: {
        p_code: 'WORK_TP',
        id: null,
        code: null,
        desc: null
      },
      columns: [
        {
          headerName: this.$t('grid.column.code'),
          field: 'code',
          tooltipField: 'code',
          width: 100
        },
        {
          headerName: this.$t('grid.column.desc'),
          tooltipField: 'desc',
          field: 'desc'
        }
      ],
      rows: [
        {
          code: 'abc',
          desc: 'Hello world',
          order: 1
        },
        {
          code: 'abc',
          desc: 'Hello world',
          order: 1
        },
        {
          code: 'abc',
          desc: 'Hello world',
          order: 1
        },
        {
          code: 'abc',
          desc: 'Hello world',
          order: 1
        }
      ]
    }
  },
  watch: {
    dialogFormVisible() {
      this.dialogFormVisible ? null : this.resetInfo()
    }
  },
  mounted() {
    this.attachData()
  },
  methods: {
    async addRow() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }
      await addCode(this.item)
        .then(async res => {
          const message = res.message
          await this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`code.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: message
          })
        })
    },
    editRow() {
      const gridApi = this.$refs.agGrid.gridApi
      const rowSelected = gridApi.getSelectedRows()[0]
      Object.assign(this.item, rowSelected)
      this.isEdit = true
      this.dialogFormVisible = true
      // console.log('rowsSelected', rowSelected)
    },
    async updateRow() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }
      await updateCode(this.item)
        .then(async res => {
          const message = res.message
          await this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`code.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: message
          })
        })
    },
    async deleteRow() {
      const gridApi = this.$refs.agGrid.gridApi
      const row = gridApi.getSelectedRows()[0]
      if (!row) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.selectRow')
        })
        return false
      }
      this.$vxConfirm(this.$t('alert.deleteConfirm'), async () => {
        const data = {
          ids: [row.id]
        }
        await deleteCode(data)
          .then(async res => {
            const message = res.message
            await this.attachData()
            this.dialogFormVisible = false
            this.$message({
              type: 'success',
              message: this.$t(`code.${message}`)
            })
          })
          .catch(error => {
            const message = error.response?.data?.message || 'default'
            this.$message({
              type: 'error',
              message: this.$t(`errorMsg.${message}`)
            })
          })
      })
    },
    async attachData() {
      await getCode(this.item).then(res => {
        this.rows = res.data
        this.rowSelected = false
      })
    },
    resetInfo() {
      this.isEdit = false
      this.item = {
        p_code: 'WORK_TP',
        id: null,
        code: null,
        desc: null
      }
    }
  }
}
</script>

<style lang="scss"></style>
